import { RouteLocationNormalized } from 'vue-router';
import { addonStateLoaded, hasAddon } from '~/plugins/addon';
import { GateRedirect, resolveGate } from './gate';

class Addon implements Middleware {
    name(): string {
        return 'addon';
    }

    async run(to: RouteLocationNormalized): Promise<GateRedirect | undefined> {
        if (!to.meta?.addon) return;

        const addon = to.meta.addon as string | string[];

        return resolveGate(
            to,
            () => addonStateLoaded(),
            () => hasAddon(addon),
        );
    }
}

export default new Addon();
